import React from 'react';
import {LANGUAGES} from '../../../../const/lang';
import {MenuItem, Select} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {SelectInputProps} from '@material-ui/core/Select/SelectInput';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import { TEXT_PRIMARY } from '../../../../const/colors';

interface LanguageSelectorProps {
    className?: string;
    onChangeLanguage?: SelectInputProps['onChange'];
}

const useStyles = makeStyles(() => ({
    selectWrapper: {
        '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            minHeight: 'unset',
            color: TEXT_PRIMARY
        },
        '& .MuiSelect-icon': {
            transform: 'translateY(-10%)',
        },
    },
    root: {
        padding: 5,
    },
}));

const LanguageSelector = ({
    className,
    onChangeLanguage,
}: LanguageSelectorProps) => {
    const {i18n} = useTranslation();
    const currentLanguage = i18n?.language.split('-')[0];
    const classes = useStyles();

    const handleChangeLanguage = (event: React.ChangeEvent<{name?: string; value: unknown;}>) => {
        i18n.changeLanguage(event.target?.value === 'pl' ? 'pl-PL' : 'en-US');
    }

    return (
        <Select
            value={currentLanguage}
            style={{width: 50}}
            className={clsx(className, classes.selectWrapper)}
            onChange={handleChangeLanguage}
            disableUnderline
            classes={{root: classes.root}}
        >
            {LANGUAGES.map(lang => (
                <MenuItem key={lang.value} value={lang.value}>
                    {lang.name}
                </MenuItem>
            ))}
        </Select>
    );
};

export default LanguageSelector;
